// src/lib/permissions-bus.js
// Centralize global WS handling for permissions
import { getSocket } from "./socket";

const MATRIX_STORAGE_KEY = "permissions.matrix.v1";

function saveLocalAndNotify(matrix) {
  try {
    localStorage.setItem(MATRIX_STORAGE_KEY, JSON.stringify(matrix));
    window.dispatchEvent(new Event("permissions:changed")); // Sidebar/SettingsNav can re-read
  } catch {}
}

let wired = false;

export function wirePermissionsRealtime() {
  if (wired) return;
  wired = true;

  const socket = getSocket();

  socket.on("permissions:matrixUpdated", (payload) => {
    if (!payload?.matrix) return;
    // Normalize shape defensively if you add new keys later
    saveLocalAndNotify(payload.matrix);
  });
}
